import { Button } from '@/common/ui/Form/Button'
import { Fieldset } from '@/common/ui/Form/Fieldset'
import { Input } from '@/common/ui/Form/Input'
import { cn } from '@/common/lib/cn/cn'
import { useOrgAddForm } from '../model'
import { useEffect } from 'react'

export const AddOrgForm = ({ className }: { className?: string }) => {
    const { form, handleSubmit, onSubmit, register, isPending, isSuccess } = useOrgAddForm()

    useEffect(() => {
        if (isSuccess) {
            form.reset()
            const checkbox = document.getElementById('addOrgModal') as HTMLInputElement

            if (checkbox) {
                checkbox.checked = false
            }
        }
    }, [isSuccess, form])

    return (
        <form className={cn('modal-form', className)} onSubmit={handleSubmit(onSubmit)}>
            <div className='modal-form-fields'>
                <div className='modal-form-field'>
                    <Fieldset errorText={form.formState.errors.name?.message} required>
                        <Input
                            emphasis='neutral'
                            className='w-full'
                            size='lg'
                            placeholder='Введите название организации'
                            type='text'
                            {...register('name', {
                                required: 'Название организации обязательно',
                            })}
                        />
                    </Fieldset>
                </div>
            </div>
            <div className='modal-form-actions'>
                <Button
                    className='w-full'
                    emphasis='accent'
                    size='xl'
                    type='submit'
                    disabled={isPending}
                    loading={isPending}
                >
                    Добавить
                </Button>
                <Button
                    as='label'
                    htmlFor='addOrgModal'
                    className='w-full'
                    emphasis='secondary'
                    size='lg'
                    variant='ghost'
                >
                    Отмена
                </Button>
            </div>
        </form>
    )
}
